// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.build-expression {
  margin-left: 1%;
  margin-right: 1%;
}

.ap {
  width: 50%;
  height: 50%;
  border-radius: 5px;
  background-color: #17A0B4;
  color: white;
  margin-left: 1%;
  margin-right: 1%;
  border: none;
}

.app-expression-builder {
  width: 80%;
  height: 80%;
  box-sizing: border-box;
  border-radius: 10px 10px 10px 10px;
  box-shadow: 0px 10px 50px 20px darkgrey;
}

:host ::ng-deep .mat-mdc-raised-button.mat-primary {
  background-color: #17A0B4;
  color: white;
}
:host ::ng-deep .mat-mdc-raised-button:disabled {
  color: grey;
}
:host ::ng-deep .custom-dialog-container .mat-dialog-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}
:host ::ng-deep .Predicate-dialog-container.mat-dialog-container {
  width: 67% !important;
  height: 66% !important;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  max-height: 18vw !important;
  max-width: 18vw !important;
  overflow: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/rule-config-component/rule-config-component.component.scss"],"names":[],"mappings":"AAAA;EAMI,eAAA;EACA,gBAAA;AAJJ;;AAQA;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AALJ;;AAQA;EACI,UAAA;EACA,WAAA;EACA,sBAAA;EACA,kCAAA;EACA,uCAAA;AALJ;;AASI;EACI,yBAAA;EACA,YAAA;AANR;AAQI;EACI,WAAA;AANR;AASI;EAGI,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,UAAA;AAVR;AAaM;EACE,qBAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,2BAAA;EACA,0BAAA;EACA,cAAA;AAXR","sourcesContent":[".build-expression {\r\n    // width: 100%;\r\n    // height: 100%;\r\n    // border-radius: 5px;\r\n    // background-color: #17A2B8;\r\n    // color: white;\r\n    margin-left: 1%;\r\n    margin-right: 1%;\r\n    // border: none;\r\n}\r\n\r\n.ap {\r\n    width: 50%;\r\n    height: 50%;\r\n    border-radius: 5px;\r\n    background-color: #17A0B4;\r\n    color: white;\r\n    margin-left: 1%;\r\n    margin-right: 1%;\r\n    border: none;\r\n}\r\n\r\n.app-expression-builder {\r\n    width: 80%;\r\n    height: 80%;\r\n    box-sizing: border-box;\r\n    border-radius: 10px 10px 10px 10px;\r\n    box-shadow: 0px 10px 50px 20px darkgrey;\r\n}\r\n\r\n:host ::ng-deep {\r\n    .mat-mdc-raised-button.mat-primary {\r\n        background-color: #17A0B4;\r\n        color: white;\r\n    }\r\n    .mat-mdc-raised-button:disabled{\r\n        color: grey;\r\n    }\r\n\r\n    .custom-dialog-container .mat-dialog-container {\r\n        //width: 67% !important;\r\n        //height: 43% !important;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        //background: white; // Adjust as needed\r\n        padding: 0; // Remove default padding\r\n      }\r\n\r\n      .Predicate-dialog-container.mat-dialog-container {\r\n        width: 67% !important;\r\n        height: 66% !important;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;   \r\n        padding: 0; \r\n        max-height: 18vw !important;  \r\n        max-width: 18vw !important;\r\n        overflow: auto; \r\n      }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
